import { throttle } from './Util.js';


const $breadcrumbs = $('.js-breadcrumbs');
const $scrollHeader = $('.js-scroll-header');
const scrollHeaderHideTop = $scrollHeader.is('[data-hide-top]');
let lastScrollTop = -1;

/* Прилипангие хлебных крошек при скролле */

if ($breadcrumbs.length) {
    App.W.on('scroll', throttle(fixedBreadcrumbs, 100));
}

if ($scrollHeader.length) {
    App.W.on('scroll', throttle(showHideHeader, 100));
}

$('.js-header-world-btn').each(function () {
    $(this).on('click', function () {
        if ($(this).parent().hasClass('_opened')) {
            $(this).parent().removeClass('_opened');

            const $sites = $('.js-header-world-nav').find('.js-header-world-sublist [data-idx]');
            $sites.removeClass('_active');
            $sites.filter('[data-idx="' + $(this).data('idx') + '"]').addClass('_active');
        } else {
            $(this).parent().addClass('_opened');
            $('.js-header-world-sublist [data-idx]').removeClass('_active').eq(0).addClass('_active');
        }
    });
    $(this).one('mouseenter', function () {
        $('.js-header-world-list [data-flag]').each(function () {
            $(this).css('background-image', 'url(' + $(this).data('flag') + ')');
        });
    });
});

App.H.on('click', function(e) {
    if (!$(e.target).parents().addBack().is('.js-header-world-nav') && !$(e.target).parents().addBack().is('.js-header-world-btn')) {
        $('.js-header-world-btn').parent().removeClass('_opened');

        const $sites = $('.js-header-world-nav').find('.js-header-world-sublist [data-idx]');
        $sites.removeClass('_active');
        $sites.filter('[data-idx="' + $(this).data('idx') + '"]').addClass('_active');
    }
});

$('.js-header-world-nav').each(function () {
    const $countries = $(this).find('.js-header-world-list [data-idx]');
    const $sites = $(this).find('.js-header-world-sublist [data-idx]');

    $countries.on('click', function () {
        $sites.removeClass('_active');
        $sites.filter('[data-idx="' + $(this).data('idx') + '"]').addClass('_active');
    });
});

App.D.ready(function () {
    $('.js-stada-group').addClass('shown');
});

App.D.on('click', '.js-location-item', function() {
    let locationUrl = $(this).parents('.js-location-change').data('url');

    $.ajax({
        method: "GET",
        url: locationUrl,
        dataType: "json",
        data: {
            'location': $(this).data('location')
        },
        success: (response) => {
            if (response.success) {
                $('.js-location-selected').text($(this).text());
                setTimeout (function() {
                    App.D.trigger('acceptCity');
                    window.location.reload();
                }, 200);
            }
        },
        error: () => {
            console.log('Ошибка получения данных');
        }
    });
});


App.D.on('click', '.js-mobile-search-btn', function() {
    $('.js-mobile-search').addClass('_active');
});

$('.js-mobile-menu').on('click', function(e){
    if( !$(e.target).parents().addBack().is('.js-mobile-search') ){
        $('.js-mobile-search').removeClass('_active');
    }
});

$('.js-mobile-search-hide').on('click', function(e){
    $('.js-mobile-search').removeClass('_active');
});


App.D.on('keyup', '.js-search-field', function(e) {
    const $searchInput = $(this);
    const $searchForm = $searchInput.parents('form');

    if (e.keyCode == 13) {
        $searchForm.submit();
    }
});

App.D.on('focus', '.js-search-field', function(e) {
    let $searchInput = $(this);
    let $searchInputWrap = $searchInput.closest('.js-search');

    $searchInputWrap.addClass('_focus');
    App.H.addClass('_search-opened');
    $('.js-mobile-menu').scrollTop(0);
});

App.B.on('click', function(e){
    if (!$(e.target).closest('.js-filter-search, .js-search-field').length){
        $('.js-search').removeClass('_focus');
        App.H.removeClass('_search-opened');
    }
});


function fixedBreadcrumbs() {
    const scrollTop = App.W.scrollTop();
    const $content = $('.content,.c-content');
    let contentHeight = 0;

    $content.each((ind, item) => {
        contentHeight += $(item).outerHeight();
    });
    const fullScreenHeight = $content.offset().top + contentHeight + $('.footer,.c-footer').outerHeight();

    $breadcrumbs.nextAll().not(":hidden, .js-common-popup").first().css({
        'margin-top': `${$breadcrumbs.outerHeight()}px`
    });

    if (scrollTop >= fullScreenHeight - App.H.outerHeight()) {
        App.H.addClass('_free-breadcrumbs');
    } else {
        App.H.removeClass('_free-breadcrumbs');
    }

}
fixedBreadcrumbs();

function showHideHeader() {
    let scrollTop = App.W.scrollTop();

    if (scrollTop < 0) scrollTop = 0;
    if (lastScrollTop < 0) lastScrollTop = 0;

    if ($scrollHeader.length) {
        if (scrollTop > lastScrollTop) {// скроллим вниз
            $scrollHeader.addClass(scrollHeaderHideTop ? '_hide-top' : '_hide-menu');
        } else {
            $scrollHeader.removeClass(scrollHeaderHideTop ? '_hide-top' : '_hide-menu');
        }
    }

    lastScrollTop = scrollTop;
}

// location reminder
$('.js-dropdown-modal-reminder').each(function() {
    const $reminder = $(this);
    const $accept = $('.js-dropdown-modal-accept', $reminder);
    const $close = $('.js-dropdown-modal-close', $reminder);
    const $changer = $('.js-dropdown-modal-open-changer', $reminder);
    const $locationChange = $('.js-location-change');
    const $locationChangeToggle = $locationChange.siblings('.js-dropdown-modal-open');

    if (!$.cookie('acceptCity')) {
        // var date = new Date();
        // date.setTime(date.getTime() + (60 * 1000));
        $.cookie('acceptCity', 'no', {expires: 3, path: '/'});
        $reminder.addClass('_opened');
    }

    $accept.on('click', function() {
        $reminder.removeClass('_opened');
        $.cookie('acceptCity', 'yes', {expires: 365, path: '/'});
    });

    $close.on('click', function() {
        $reminder.removeClass('_opened');
    });

    $changer.on('click', function() {
        $reminder.removeClass('_opened');console.log($locationChangeToggle);
        requestAnimationFrame(function() {
            $locationChangeToggle.click();
        });
    });

    App.D.on('acceptCity', function() {
        $.cookie('acceptCity', 'yes', {expires: 365, path: '/'});
    });
});
